export default {
  spreadsheetTips: 'Consejos de hoja de cálculo',
  tip1: 'Los datos se pueden seleccionar y copiar desde/hacia cualquier software de hoja de cálculo',
  tip2: 'Los valores modificados por el usuario se muestran usando',
  thisColor: 'este color',
  tip3: 'Al eliminar el valor de una celda, volverá a su valor predeterminado',
  tip4: 'Después de ingresar datos en una celda, puedes presionar Enter para bajar o Tab para ir a la derecha',
  close: 'Cerrar',
  period: 'Período',
  valueVariousUnits: 'Valor (varias unidades)',
  externalVariables: 'Variables externas',
  series: 'Series'
}
